import { createStyles, makeStyles, Theme } from '@material-ui/core'
import Backdrop from '@material-ui/core/Backdrop'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

import './App.css'
import { Auth, Hub } from 'aws-amplify'
import Cookies from 'js-cookie'
import * as R from 'ramda'
import React, { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { Router } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components'

import GlobalStyle from '../components/styled/global'
import config from '../config'
import history from '../history'
import { logoutRequest, signInSucceed } from '../redux/auth/actions'
import { showBackdropMessage } from '../redux/message/actions'
import { BackdropMessageState } from '../redux/message/reducers'
import { getBackDropMessageSelector } from '../redux/message/selectors'
// import { listGroupUserNames } from '../utils/aws.cognito'
import { Navigation, NavigationType } from './Navigation'

import DateFnsUtils from '@date-io/date-fns'

const queryClient = new QueryClient()

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    }
  })
)

const StyledBackdropMessageBox = styled(Paper)`
  width: 400px;
  height: 150px;
  padding: 20px;
`

const App = () => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const backdropMessage = useSelector(
    getBackDropMessageSelector
  ) as BackdropMessageState

  const signOutHandler = (): void => {
    Cookies.remove(config.authCookieName)
    dispatch(logoutRequest())
  }

  useEffect(() => {
    Hub.listen('auth', async ({ payload: { event, data } }): Promise<void> => {
      switch (event) {
        case 'signIn':
          const groups =
            data.signInUserSession.accessToken.payload['cognito:groups'] || []

          // const authorizedUserNames = await listGroupUserNames(
          //   config.aws.cognito.authorizedUsersGroupName,
          //   config.aws.cognito.userPoolId
          // )
          console.log('groups', groups)
          console.log(
            'config.aws.cognito.authorizedUsersGroupName',
            config.aws.cognito.authorizedUsersGroupName
          )
          // if (authorizedUserNames?.includes(data.username)) {
          if (groups.includes(config.aws.cognito.authorizedUsersGroupName)) {
            const jwt = data.signInUserSession.accessToken.jwtToken
            Cookies.set(config.authCookieName, jwt, {
              expires: config.cookies.defaultExpireTime
            })
            dispatch(signInSucceed())
            history.push('/')
          } else {
            dispatch(
              showBackdropMessage([
                'Your account is not authorized to use the control panel.  Please add your account to the authorized list',
                'Logging you out in 3 seconds'
              ])
            )
            setTimeout(() => {
              void Auth.signOut()
            }, config.delayMS.forceLogout)
          }
          break
        case 'oAuthSignOut':
          signOutHandler()
          break
        case 'signOut':
          signOutHandler()
          break
        default:
          console.log(event, data)
      }
    })
  }, [])

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <QueryClientProvider client={queryClient}>
        <Router history={history}>
          <GlobalStyle />
          <Switch>
            {Navigation.map(
              ({ key, path, component, exact }: NavigationType) => (
                <Route
                  key={key}
                  path={path}
                  component={component}
                  exact={R.defaultTo(true, exact)}
                />
              )
            )}
          </Switch>
          <Backdrop className={classes.backdrop} open={backdropMessage.show}>
            <StyledBackdropMessageBox>
              {backdropMessage.messages.map((message) => (
                <>
                  <Typography variant="subtitle1">{message}</Typography>
                  <br />
                </>
              ))}
            </StyledBackdropMessageBox>
          </Backdrop>
        </Router>
      </QueryClientProvider>
    </MuiPickersUtilsProvider>
  )
}

export default App
